import type {SelectItem} from '@jetbrains/ring-ui/components/select/select'
import {useMemo} from 'react'

import {useAppDispatch, useAppSelector} from '../../../../../../../../../hooks/react-redux'
import {restApi} from '../../../../../../../../../services/rest'
import {usePipelineExistingJob} from '../../../../../../EditPipelinePage/EditPipelinePage.hooks'
import {getJobAgent} from '../../../../../../EditPipelinePage/EditPipelinePage.selectors'
import {pipelineDraft} from '../../../../../../EditPipelinePage/slices/EditPipelinePage.slices'
import {usePipelineId} from '../../../../../../hooks/pipeline'

import {cloudImageHardware} from './JobAgentRequirements.consts'

import styles from './JobAgentRequirements.css'

function useJobAgentRequirements(jobId: string) {
  const dispatch = useAppDispatch()
  const id = usePipelineId()
  const jobAgent = useAppSelector(getJobAgent(jobId, id))
  const pipelineExistingJob = usePipelineExistingJob(jobId)
  const {cloudImage = []} = restApi.endpoints.getAllCloudImages.useQuery(
    {},
    {
      selectFromResult: ({data}) => ({
        cloudImage: data?.cloudImage,
      }),
    },
  )
  const agents = useMemo(
    () =>
      cloudImage
        .map(({name}) => {
          const details = cloudImageHardware[name!]?.details?.join(` / `)
          const glyph = cloudImageHardware[name!]?.icon

          return {
            key: name,
            label: name,
            className: styles.selectItem,
            glyph,
            details,
          }
        })
        .sort(({label = ''}, {label: prevLabel = ''}) => prevLabel.localeCompare(label)),
    [cloudImage],
  ) as SelectItem[]
  const selectedCloudImage = useMemo(
    () => agents.find(({label}) => label === jobAgent),
    [agents, jobAgent],
  )
  const handlerColudImageSelect = (value: SelectItem | null) =>
    dispatch(
      pipelineDraft.actions.setAgent({
        id,
        jobId,
        agent: value?.key?.toString(),
      }),
    )
  const isUnsaved =
    pipelineExistingJob && pipelineExistingJob?.['runs-on'] !== selectedCloudImage?.key

  return {
    selectedCloudImage,
    agents,
    isUnsaved,
    handlerColudImageSelect,
  }
}

export default useJobAgentRequirements
